// ##### 23-03-29 Komarov
import { CloseCircleFilled } from '@ant-design/icons';
// ##### 25-05-21 Komarov
import React, { useState } from 'react';

// ##### Komarov 2025-07-14
const ClearInput = ({ clearInput }) => {
  const [crossColor, setCrossColor] = useState('#c9c9c9');

  const onMouseEnter = () => {
    setCrossColor('slategrey');
  };

  const onMouseLeave = () => {
    setCrossColor('#c9c9c9');
  };

  return (
    <div
      data-component="ClearInput"
      className="visibleCross"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={clearInput}
      // ##### 24-03-21 Komarov
      onKeyDown={event => {
        if (event.key === 'Enter') {
          clearInput();
        }
      }}
    >
      {/* <CloseCircleFilled style={{color:'#96c6f0'}}/> */}
      <CloseCircleFilled style={{ color: crossColor }} />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default ClearInput;
